import { render, staticRenderFns } from "./chooseHousekeepingServFee.vue?vue&type=template&id=6fad9d80&scoped=true"
import script from "./chooseHousekeepingServFee.vue?vue&type=script&lang=js"
export * from "./chooseHousekeepingServFee.vue?vue&type=script&lang=js"
import style0 from "./chooseHousekeepingServFee.vue?vue&type=style&index=0&id=6fad9d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fad9d80",
  null
  
)

export default component.exports